import { useTooltip_unstable } from "@fluentui/react-components";

import type { AppTooltipProps, AppTooltipState } from "./AppTooltip.types";
import { useConvertTooltipContent } from "../../../hooks/useConvertTooltipContent";
import { useAppTooltipClass } from "./AppTooltip.styles";
import { compareTootlipAndElementLabel } from "./../../../utilities/compareTootlipAndElementLabel";

export const useAppTooltip = (
  props: AppTooltipProps,
  visible?: boolean,
  setVisible?: (visible: boolean) => void
): AppTooltipState => {
  const className = useAppTooltipClass(props.tooltipClassName);
  const state = useTooltip_unstable({
    ...props,
    content: {
      children: useConvertTooltipContent(props, setVisible),
      className,
    },
    relationship: props.relationship || "label",
    withArrow: props.withArrow || true,
    positioning: props.positioning || "below",
    onVisibleChange: (_event, data) =>
      setVisible?.(
        data.visible &&
          compareTootlipAndElementLabel(props.tooltipLabel, props.elementId)
      ),
    visible,
    hideDelay: 70,
  });
  state.shouldRenderTooltip = state.visible;
  return state as AppTooltipState;
};
